
import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { CreateElement, RenderContext, VNode } from 'vue';

export default defineComponent({
  functional: true,
  props: {
    vnodes: {
      type: Object as PropType<VNode>,
      required: true,
    },
  },
  render: (_: CreateElement, context: RenderContext) => context.props.vnodes,
});
